import React from 'react';
import { Card } from '../../components/ui/card';
import { History } from 'lucide-react';
import BikerLayout from '../../components/biker/BikerLayout';

const BikerHistory = () => {
  return (
    <BikerLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Delivery History</h1>
          <p className="text-gray-600 mt-1">View your completed deliveries</p>
        </div>

        <Card className="p-12 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-4">
            <History className="h-8 w-8 text-gray-400" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">No Delivery History</h2>
          <p className="text-gray-600">
            Your completed deliveries will appear here.
          </p>
        </Card>
      </div>
    </BikerLayout>
  );
};

export default BikerHistory;
